export default __webpack_public_path__ + "static/media/tick.71c6fd61.svg";